import React from 'react';
import classNames from 'classnames';
import withUnit from '../utils/with-unit';

const defaultStyles = {};

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
function PanelGroup({
  height = 'auto',
  className = '',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
  rootRef = null,
  children,
  style = defaultStyles,
  ...otherProps
}) {
  const classes = classNames('ws-panel-group', className);

  return (
    <div
      className={classes}
      style={{ ...style, height: withUnit(height) }}
      ref={rootRef}
      {...otherProps}
    >
      {children}
    </div>
  );
}

export default PanelGroup;
